import { RootState } from '@reducers';

export const selectHealthPolicyClaim = (state: RootState) =>
  state.userDashboardRouteReducer.policyClaim.healthPolicyClaim;
